/**
 * Create a login url and attach redirectUrl as a search param for redirecting back to the current page
 * @param [baseUrl=''] optional base url
 */
export const composeLoginPathWithRedirectUrl = (baseUrl: string = '') => {
  const loginSearchParams = new URLSearchParams()
  // Add current url including search params as redirectUrl
  loginSearchParams.set('redirectUrl', window.location.href)

  return `${baseUrl}/login?${loginSearchParams.toString()}`
}
